import { FC } from "react";
import { Button, Container, Modal, Row, Col } from "react-bootstrap";
import { ModalPropTypes } from "./types";
import style from "./style.module.scss";

export const FormatFileModal: FC<ModalPropTypes> = (props) => {
  const { show, closeModal } = props;

  return (
    <Modal
      show={show}
      centered
      scrollable
      fullscreen="sm-down"
      dialogClassName={style.modal}
    >
      <Modal.Header className="d-flex justify-content-center align-items-center border-bottom-0">
        <Modal.Title className="text-light fs-3 fw-bold text-center">
          Formati file supportati
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="grid-example mb-4">
        <Container className="mb-4">
          <Row>
            <Col md={6} xs={6}>
              <h5 className="text-center text-primary">Immagini</h5>
              <hr className="border border-primary opacity-75" />
              <ul className="text-center px-2">
                <li className="list-group-item text-light">PNG</li>
                <li className="list-group-item text-light">JPG</li>
                <li className="list-group-item text-light">JPEG</li>
              </ul>
            </Col>
            <Col md={6} xs={6}>
              <h5 className="text-center text-primary">File di testo</h5>
              <hr className="border border-primary opacity-75 " />
              <ul className="text-center px-2">
                <li className="list-group-item text-light">DOC</li>
                <li className="list-group-item text-light">DOCX</li>
                <li className="list-group-item text-light">ODT</li>
              </ul>
            </Col>
          </Row>
          <Row>
            <Col md={6} xs={6}>
              <h5 className="text-center text-primary">Fogli di calcolo</h5>
              <hr className="border border-primary opacity-75" />
              <ul className="text-center px-2">
                <li className="list-group-item text-light">XLS</li>
                <li className="list-group-item text-light">XLSX</li>
                <li className="list-group-item text-light">ODS</li>
              </ul>
            </Col>
            <Col md={6} xs={6}>
              <h5 className="text-center text-primary">Altri file</h5>
              <hr className="border border-primary opacity-75" />
              <ul className="text-center px-2">
                <li className="list-group-item text-light">PDF</li>
                <li className="list-group-item text-light">TXT</li>
              </ul>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center border-top-0 pt-4 mt-2">
        <Button variant="outline-light" onClick={closeModal} className="mt-4">
          Chiudi
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
